<template>
  <div class="songcard p-shadow-1" :style="'background-color:' + bgColor">
    <img
      class="p-m-0"
      :src="'http://img.youtube.com/vi/' + videoId + '/default.jpg'"
    />
    <h3 class="title">{{ screenTitle }}</h3>
    <div class="tags">
      <div class="chips">
        <template v-for="item in tag" :key="item">
          <Chip class="chip p-mx-1" :label="item"></Chip>
        </template>
      </div>
    </div>
    <Button
      @click="addList"
      v-if="displayButton && !added"
      icon="pi pi-plus"
      class="button p-button-raised p-button-rounded"
    />
    <Button
      @click="removeList"
      v-if="added && !nowPlaying"
      icon="pi pi-minus"
      class="button p-button-raised p-button-rounded p-button-secondary"
    />
    <div v-if="nowPlaying" class="button text">Now Playing</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Chip from "primevue/chip";
import firebase from "../firebase/firebase";
import { useStore } from "vuex";
import Button from "primevue/button";

export default defineComponent({
  name: "SongCard",
  components: { Chip, Button },
  props: {
    songId: {
      type: String,
      default: "",
    },
    displayButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const tag: Array<string> = [];
    return {
      screenTitle: "",
      tag: tag,
      videoId: "",
    };
  },
  setup() {
    const store = useStore();
    return {
      store,
    };
  },
  computed: {
    bgColor(): string {
      if (
        this.store.state.list.ids[this.store.state.list.cursor] == this.songId
      ) {
        return "whitesmoke";
      }
      return "white";
    },
    added(): boolean {
      return this.store.state.list.ids.includes(this.songId);
    },
    nowPlaying(): boolean {
      return (
        this.store.state.list.ids[this.store.state.list.cursor] == this.songId
      );
    },
  },
  mounted: async function () {
    await firebase
      .firestore()
      .collection("songs")
      .doc(this.songId)
      .get()
      .then((d) => {
        const tmp: any = d.data();
        this.screenTitle = tmp.screenTitle;
        this.videoId = tmp.videoId;
        tmp.tag.forEach((element: string) => {
          this.tag.push(element);
        });
      });
    console.log("songcard mounted");
  },
  methods: {
    addList() {
      this.store.commit("addList", this.songId);
    },
    removeList() {
      this.store.commit("removeList", this.songId);
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.songcard {
  padding-left: 120px;
  width: 90%;
  max-width: 1020px;
  height: 90px;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  margin-top: 16px;
}
img {
  position: absolute;
  top: 0;
  left: 0;
}
.chip {
  font-size: 8pt;
}
.chips {
  white-space: nowrap;
  overflow:auto;
  padding-right:100px;
}
.title {
  font-size: 12pt;
}

.tags {
  text-align: left;
  padding-left: 16px;
}
h3 {
  padding-top: 0px;
  padding-left: 16px;
  text-align: left;
}
.button {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.text {
  height: 20px;
  width: 100px;
  text-align: center;
  background-color: #41a2f1;
  font-size: 8pt;
  line-height: 20px;
  border-radius: 30px;
  color: white;
  font-weight: bold;
}
</style>
